import { useEffect } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import React from "react";

import { FaQuestionCircle } from "react-icons/fa";
import { Sparkles } from "lucide-react";

const faqs = [
  {
    question: " How long does a renovation project take?",
    answer: "Project timelines vary depending on the size and complexity of the work. We provide clear timelines during the consultation process."
  },
  {
    question: "Do you provide free quotes?",
    answer: "Yes, we offer free consultations and no-obligation quotes for all projects."
  },
  {
    question: "Can you handle complete renovations?",
    answer: "Yes, we manage complete renovation projects from planning and design to construction and finishing."
  },
   {
    question: "Do you work with custom designs?",
    answer: "Absolutely. We tailor every project to match your preferences, style, and requirements."
  },
   {
    question: "What areas do you cover?",
    answer: "We provide our services across local and surrounding areas. Contact us to discuss your location and project requirements."
  }  
 
];

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.2 } })
};

const AccordionItem = ({ faq, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.div
      variants={fadeIn}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      custom={index}
      className="mb-4 border border-blue-200 rounded-xl overflow-hidden bg-gray-50 shadow-md"
    >
      <button
        className="w-full px-6 py-4 text-left font-semibold text-slate-900 flex justify-between items-center hover:bg-blue-50 transition duration-300"
        onClick={() => setIsOpen(!isOpen)}
      >
        {faq.question}
        <span className={`transform transition-transform text-teal-600 ${isOpen ? "rotate-180" : "rotate-0"}`}>
          ▼
        </span>
      </button>
      {isOpen && (
        <div className="px-6 pb-4 text-gray-700 text-sm leading-relaxed">
          {faq.answer}
        </div>
      )}
    </motion.div>
  );
};


export default function FAQs() {
    const [step, setStep] = useState('initial');
  const [selectedOption, setSelectedOption] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


 
  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
  {/* Background Video with Zoom Out */}
  <motion.div
    initial={{ scale: 1.2 }}
    animate={{ scale: 1 }}
    transition={{ duration: 3, ease: "easeOut" }}
    className="absolute inset-0"
  >
    <video
      className="w-full h-full object-cover"
      autoPlay
      loop
      muted
      playsInline
    >
      <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </motion.div>

  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-30" />

  {/* Heading on the Left */}
  <div className="relative z-10 h-full flex items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0 ml-4 md:ml-8">
  <div className="relative inline-block">
  <motion.div
    initial={{ opacity: 0, y: 80 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 2, ease: "easeOut" }}
    className="bg-black bg-opacity-40 rounded-xl shadow-xl px-6 py-4"
  >
    <h1 className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold leading-tight">
      FAQs
    </h1>
  </motion.div>

  <motion.div
    animate={{ y: [0, -14, 3, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute top-[-20px] left-[-20px] w-[70px] h-[80px] border-t-[22px] border-l-[22px] border-teal-500 opacity-25 "
  />
</div>
    
  </div>
</div>




  <div className="min-h-screen bg-slate-800 p-6">
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl md:text-5xl font-bold text-white flex justify-center items-center gap-2">
          <FaQuestionCircle className="text-blue-600" /> Frequently Asked Questions
        </h1>
        
        <p className="text-gray-400 mt-2 max-w-xl mx-auto">
          Find answers to the most common questions below.
        </p>
      </motion.div>

      <div className="max-w-3xl mx-auto">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} faq={faq} index={index} />
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="mt-16 flex justify-center"
      >
        <Sparkles className="text-teal-500 animate-pulse w-12 h-12" />
      </motion.div>
    </div>

</div>

  
  );
}
